import styled from 'styled-components';

export const LogoStyled = styled.img`
  height: 50px;
  margin: 25px 10px;
`;
